import { Form } from 'antd';
import styled, { css } from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type FormFieldProps = {
  $thin?: boolean;
  $tip?: boolean;
};

export const FormField = styled(Form.Item)<FormFieldProps>`
  min-width: 50px;
  margin-bottom: 30px;
  .ant-form-item-label {
    padding-bottom: 5px;
  }

  label {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p.tip,
  .ant-form-item-label > label,
  input,
  .ant-form-item-explain {
    line-height: 15px;
    font-size: 12px;
  }

  p.tip {
    color: ${COLOR.OUTER_SPACE};
    margin-bottom: 10px;
  }

  .ant-form-item-label > label {
    font-weight: bold;
    color: ${COLOR.OUTER_SPACE};
  }

  input,
  .ant-select-selector {
    height: ${({ $thin }) => ($thin ? '38px' : '40px')} !important;
  }

  &&& .ant-select-selection-placeholder,
  &&& .ant-select-selection-item {
    line-height: 40px;
    font-size: 12px;
  }

  .ant-form-item-explain {
    margin-top: 5px;
  }

  .ant-input-group-addon {
    padding: 0 7px;
    width: 32px;
  }

  ${({ $tip }) =>
    $tip
      ? css`
          &&& span.ant-form-item-children-icon {
            display: inline-block;
            margin-top: 3px;
          }
        `
      : ''}
`;
